import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_bodyElement", "bodyClassName", "name", "children", "enableAnimationFeatures", "isMainAppProvider"];
import classNames from 'classnames';
import { useEffect } from 'react';
import { setupStyledComponents } from '../listeners/setupStyledComponents';
import ComponentWithBodyClass from '../utils/ComponentWithBodyClass';
import { AppProvider } from 'foundations-components/components/AppProvider';

/** @internal Hidden props - ask about your use case in #trellis-support */
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIApplication(props) {
  const {
      _bodyElement = document.body,
      bodyClassName,
      name,
      children,
      enableAnimationFeatures = true,
      isMainAppProvider = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  useEffect(setupStyledComponents, []);
  return (
    /*#__PURE__*/
    // Since HubStyle already applies global styles, we don't need duplicate global styles from Foundations Components
    _jsx(AppProvider, {
      applyGlobalStyles: false,
      enableAnimationFeatures: enableAnimationFeatures,
      isMainAppProvider: isMainAppProvider,
      children: /*#__PURE__*/_jsx(ComponentWithBodyClass, {
        bodyClassName: classNames('ui-app', bodyClassName),
        bodyElement: _bodyElement,
        children: /*#__PURE__*/_jsx("div", Object.assign({
          "data-application-name": name
        }, rest, {
          children: children
        }))
      })
    })
  );
}
UIApplication.displayName = 'UIApplication';